export const LOGS_URL = process.env.REACT_APP_LOGS_URL as string;

export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';
